import React, { useEffect, useRef, useState } from 'react';
import styles from '../addCategoryForm/addCategoryForm.module.css';
import { Close, Closecircle, closeCircle, UploadImg } from '../../Svg';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { updateLevel3category } from '../../redux/level3/getAllLevel3slice';
import { exportAtributeThunk } from '../../redux/atributes/getAllAtributes';
import stylesp from './prod.module.css';

const EditLevelForm = () => {

    const thumbnailImageref = useRef()

    const [loading, setLoading] = useState(false)
    const coverImageRef = useRef(null);
    const [isCoverUploadloading, setCoverUploading] = useState(false)
    const [isOpen, setIsOpen] = useState(false);
    const { exportedData } = useSelector((state) => state.atributes);

    const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
    const categories = categoryHeirarchy?.categories
    const subcategory = categoryHeirarchy?.subcategories

    const [filteredSubcategory, setFiilteredSubcategory] = useState([])

    const categoryData = useSelector((state) => state.level3.editLevel3);
    const [categoryId, setCategoryId] = useState(categoryData?.category?._id || '')
    const [filteredData, setFilteredData] = useState(null);
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    // Website attributes: names found on this level 3's products
    const [productAttributes, setProductAttributes] = useState([]);
    const [attributesLoading, setAttributesLoading] = useState(false);
    const [attributeSearch, setAttributeSearch] = useState('');
    const [isAttributesOpen, setAttributesOpen] = useState(false);
    const attributesDropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (attributesDropdownRef.current && !attributesDropdownRef.current.contains(event.target)) {
                setAttributesOpen(false);
                setAttributeSearch('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : exportedData?.data?.filter(customer =>
                customer?.variant_name?.toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };


    // Define the Formik schema
    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        setValues,
        resetForm
    } = useFormik({
        initialValues: {
            name: categoryData?.name || '',
            cover_image: categoryData?.cover_image || null,
            thumbnail: {
                photo: categoryData?.thumbnail?.photo || null,
                status: categoryData?.thumbnail?.status || ''
            },
            parentId: categoryData?.subcategory?._id || '',
            atributes: categoryData?.atributes || [],
            displayAttributes: categoryData?.displayAttributes || []
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required('Sub Category name is required'),
        }),
        onSubmit: async (values) => {

            const status = await dispatch(updateLevel3category(values));
            if (status?.payload == 200) {
                navigate(-1);
            }

        },
    });




    const handleImageChange = async (e, attribute, repo) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        if (repo == "photo") {
            setLoading(true)
        } else {
            setCoverUploading(true)
        }

        try {
            if (file) {
                const body = new FormData()
                body.append('image', file)
                body.append("repo", `category/${repo}`)

                const { data, status } = await api.fileUpload(body)

                if (status === 200) {
                    setFieldValue(attribute, data.data)
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {
            if (repo == "photo") {
                setLoading(false)
            } else {
                setCoverUploading(false)
            }
        }
    };


    const handleSelectionChange = (manufacturerId) => {
        const { atributes } = values;
        if (atributes?.includes(manufacturerId)) {
            setFieldValue(
                "atributes",
                atributes?.filter(id => id !== manufacturerId)
            );
        } else {
            setFieldValue(
                "atributes",
                [...atributes, manufacturerId]
            );
        }
    };

    useEffect(() => {
        dispatch(exportAtributeThunk())
    }, [])

    useEffect(() => {
        if (categoryId) {
            if (subcategory?.length > 0) {
                const filteredSubcategory = subcategory?.filter(i => i?.parentId?.includes(categoryId))
                setFiilteredSubcategory(filteredSubcategory)
            }
        }
    }, [categoryId])

    const handleRemove = (repo) => {
        setFieldValue(repo, "")
    }

    useEffect(() => {
        if (!categoryData?._id) return;
        let active = true;
        setAttributesLoading(true);
        api.getLevel3Attributes(categoryData._id)
            .then(({ data }) => { if (active) setProductAttributes(data?.data || []); })
            .catch((err) => { console.log(err); if (active) setProductAttributes([]); })
            .finally(() => { if (active) setAttributesLoading(false); });
        return () => { active = false; };
    }, [categoryData?._id]);

    const displayAttributes = values?.displayAttributes || [];

    // Every attribute from the Attributes master, plus names found on this level 3's products
    // and any saved ones; attributes used by this level 3's products are listed first
    const productCountByName = new Map(productAttributes.map((a) => [a?.name, a?.products || 0]));
    const attributeOptions = [...new Set([
        ...(exportedData?.data || []).map((a) => a?.variant_name),
        ...productAttributes.map((a) => a?.name),
        ...displayAttributes,
    ].filter(Boolean))]
        .map((name) => ({ name, products: productCountByName.get(name) || 0 }))
        .sort((a, b) => (b.products > 0) - (a.products > 0) || a.name.localeCompare(b.name));
    const visibleAttributeOptions = attributeOptions.filter((a) =>
        a?.name?.toLowerCase().includes(attributeSearch.trim().toLowerCase())
    );

    const toggleDisplayAttribute = (name) => {
        setFieldValue(
            'displayAttributes',
            displayAttributes.includes(name)
                ? displayAttributes.filter((item) => item !== name)
                : [...displayAttributes, name]
        );
    };


    useEffect(() => {
        if (categoryData) {
            setValues(categoryData); // Prefill form when data is loaded
            setCategoryId(categoryData?.category?._id)
        }

    }, [categoryData, setValues]);



    return (
        <>
            <form onSubmit={handleSubmit} className={`${styles.updateCategoryContainer} ${stylesp.levelEditPage}`}>
                <div className={`${styles.genaralInfo} ${stylesp.levelMainColumn}`}>
                    <div className={`${styles.formSection} ${stylesp.levelFormSection}`}>
                        <div className={`${styles.card} ${stylesp.levelCard}`}>
                            <div className={stylesp.levelCardHeading}>
                                <span className={stylesp.levelEyebrow}>LEVEL 3 SETUP</span>
                                <h2 className={styles.addCatH2}>General information</h2>
                                <p>Set the category hierarchy and name for this website level.</p>
                            </div>
                            <div className={stylesp.levelFields}>
                            <label className={`${styles.addCatLabel} ${stylesp.levelField}`}>
                                Category Name*
                                <select
                                    className={styles.addCatSelect}
                                    onChange={(e) => setCategoryId(e.target.value)}
                                    value={categoryId}
                                >
                                    <option value="" >select</option>
                                    {categories?.length > 0 ?
                                        <>
                                            {categories?.map(category => (
                                                <option key={category._id} value={category._id}>
                                                    {category.name}
                                                </option>
                                            ))}

                                        </>
                                        :
                                        <option value="" disabled>no categories found</option>
                                    }
                                </select>
                            </label>
                            <label className={`${styles.addCatLabel} ${stylesp.levelField}`}>
                                Subcategory Name*
                                <select
                                    name='parentId'
                                    className={styles.addCatSelect}
                                    value={values.parentId}
                                    onChange={handleChange}
                                    onBlur={handleBlur}>
                                    <option value="">Select</option>
                                    {filteredSubcategory?.length > 0 ?
                                        <>
                                            {filteredSubcategory?.map(subcategory => (
                                                <option key={subcategory._id} value={subcategory._id}>
                                                    {subcategory.name}
                                                </option>
                                            ))}

                                        </>
                                        :
                                        <option value="" disabled>no categories found</option>
                                    }
                                </select>
                                {touched.parentId && errors.parentId ? (
                                    <div className={styles.errorText}>{errors.parentId}</div>
                                ) : null}
                            </label>
                            <label className={`${styles.addCatLabel} ${stylesp.levelField}`}>
                                Subcategory level 3*
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Type category name here..."
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                />
                                {touched.name && errors.name ? (
                                    <div className={styles.errorText}>{errors.name}</div>
                                ) : null}
                            </label>
                            </div>

                            
                            {/* <div className={styles.imageUpload}>
                                <p className={styles.addCatLabel}>Cover Image</p>
                                {isCoverUploadloading ? <div className={styles.uploadBox}>Please wait...</div> :
                                    <>

                                        {
                                            values.cover_image
                                                ? <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <img src={values.cover_image[0]} alt="" className={styles.previewImage} />
                                                    <div className={styles.cancel_cross} onClick={() => handleRemove("cover_image")}>
                                                        {closeCircle()}
                                                    </div>
                                                </div>
                                                :

                                                <div
                                                    className={styles.uploadBox}
                                                    onClick={() => coverImageRef.current.click()}
                                                    onDrop={(e) => { e.preventDefault(); handleImageChange(e, "cover_image", "cover_image"); }}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span className={styles.uploadIcon}><UploadImg /></span>
                                                    <p className={styles.addCatPara}>Drag and drop image here, or click to add image</p>
                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        ref={coverImageRef}
                                                        onChange={(e) => handleImageChange(e, "cover_image", "cover_image")}
                                                        accept="image/*"

                                                    />
                                                </div>
                                        }
                                    </>
                                }
                            </div> */}

                            <div className={`${styles.addCatLabel} ${stylesp.keyFeatureBlock}`}>
                                <div className={stylesp.keyFeatureHeading}>
                                    <span>Key features for exact match</span>
                                    <small>Optional</small>
                                </div>
                                <div className={`${stylesp.attributeDropdown} ${isOpen ? stylesp.attributeDropdownOpen : ''}`} ref={dropdownRef}>

                                    <div
                                        className={styles.addCatSelect}
                                        onClick={handleToggleDropdown}
                                    >
                                        Select

                                    </div>

                                    {
                                        isOpen &&
                                        <div className={stylesp.dropdownContent}>
                                            <div style={{}}>
                                                <input
                                                    type="text"
                                                    placeholder="Search..."
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        boxSizing: 'border-box',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>
                                            <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                                {(filteredData || exportedData?.data)?.map((customer) => (
                                                    <label
                                                        key={customer?._id}
                                                        className={stylesp.dropdownItem}
                                                    >
                                                        {customer?.variant_name}
                                                        <input
                                                            type="checkbox"
                                                            checked={values?.atributes?.includes(customer?.variant_name)}
                                                            onChange={() => handleSelectionChange(customer?.variant_name)}
                                                        />
                                                    </label>
                                                ))}


                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                                <button
                                                    type="button"
                                                    className={stylesp.loginButton}
                                                    style={{ borderRadius: "0px 0px 10px 10px" }}
                                                    onClick={() => setIsOpen(false)}
                                                >
                                                    Done
                                                </button>
                                            </div>
                                        </div>
                                    }

                                </div>
                                {values?.atributes?.map((i, index) => {
                                    // A previously selected attribute can be deleted from the
                                    // master list. Keep showing/removing its saved name instead
                                    // of dereferencing an undefined lookup result.
                                    const manufacturer = exportedData?.data?.find((item) => item?.variant_name === i);
                                    const attributeName = manufacturer?.variant_name || i;
                                    if (!attributeName) return null;
                                    return (
                                        <div key={`${attributeName}-${index}`} className={styles.dropdownresult}>
                                            {attributeName} <div onClick={() => handleSelectionChange(attributeName)}><Closecircle /></div>
                                        </div>
                                    )
                                })

                                }

                            </div>
                        </div>
                    </div>
                    <div className={`${styles.buttonGroup} ${stylesp.levelActions}`}>
                        <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                        <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "Update Level3"}</button>
                    </div>
                </div>

                <div className={`${styles.thumbnain} ${stylesp.levelSideColumn}`}>
                    <div className={styles.card}>
                        {/* <h2 className={styles.addCatH2}>Thumbnail</h2>
                        <p style={{ fontSize: '14px', color: '#777980', padding: '20px 0px 6px 0px' }}>Photo</p>
                        {loading ? <div className={styles.uploadBox}>please wait...</div> :
                            <>
                                {
                                    values.thumbnail.photo
                                        ? <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                            <img src={values.thumbnail.photo[0]} alt="" className={styles.previewImage} />
                                            <div className={styles.cancel_cross} onClick={() => handleRemove("thumbnail.photo")}>
                                                {closeCircle()}
                                            </div>
                                        </div>
                                        :
                                        <div className={styles.uploadBox}
                                            onClick={() => thumbnailImageref.current.click()}
                                            onDrop={(e) => { e.preventDefault(); handleImageChange(e, 'thumbnail.photo', 'photo'); }}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <span className={styles.uploadIcon}>
                                                <UploadImg />
                                            </span>
                                            <p className={styles.addCatPara}>Drag and drop image here, or click add image</p>
                                            <button type="button" className={styles.addImgBtn} >Add Image</button>
                                            <input type="file" name="" id=""
                                                ref={thumbnailImageref}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImageChange(e, 'thumbnail.photo', 'photo')}
                                                accept="image/*"
                                            />

                                        </div>
                                }
                            </>
                        } */}
                        <div className={`${styles.card} ${stylesp.levelCard} ${stylesp.statusCard}`}>
                            <div className={stylesp.levelCardHeading}>
                                <span className={stylesp.levelEyebrow}>VISIBILITY</span>
                                <h2 className={styles.addCatH2}>Status</h2>
                                <p>Control whether this level is active for the website.</p>
                            </div>
                            <label className={`${styles.addCatLabel} ${stylesp.levelField}`}>
                                Category Status*
                                <select
                                    name="thumbnail.status"
                                    className={styles.addCatSelect}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.thumbnail.status}
                                >
                                    <option value="">Select...</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="INACTIVE">Inactive</option>
                                </select>
                            </label>
                        </div>

                        <div className={`${styles.card} ${stylesp.levelCard} ${stylesp.websiteAttributesCard}`}>
                            <div className={stylesp.levelCardHeading}>
                                <h2 className={styles.addCatH2}>Attributes</h2>
                            </div>
                            <div className={`${styles.addCatLabel} ${stylesp.keyFeatureBlock}`}>
                                <div className={`${stylesp.attributeDropdown} ${isAttributesOpen ? stylesp.attributeDropdownOpen : ''}`} ref={attributesDropdownRef}>
                                    <div
                                        className={styles.addCatSelect}
                                        onClick={() => {
                                            setAttributesOpen((open) => !open);
                                            setAttributeSearch('');
                                        }}
                                    >
                                        Select
                                    </div>

                                    {isAttributesOpen &&
                                        <div className={stylesp.dropdownContent}>
                                            <div>
                                                <input
                                                    type="text"
                                                    placeholder="Search..."
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        boxSizing: 'border-box',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                    value={attributeSearch}
                                                    onChange={(e) => setAttributeSearch(e.target.value)}
                                                />
                                            </div>
                                            <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                                {visibleAttributeOptions.length === 0 && (
                                                    <div className={stylesp.dropdownItem}>
                                                        {attributesLoading ? 'Loading...' : 'No attributes found'}
                                                    </div>
                                                )}
                                                {visibleAttributeOptions.map((attribute) => (
                                                    <label key={attribute.name} className={stylesp.dropdownItem}>
                                                        {attribute.name}
                                                        <input
                                                            type="checkbox"
                                                            checked={displayAttributes.includes(attribute.name)}
                                                            onChange={() => toggleDisplayAttribute(attribute.name)}
                                                        />
                                                    </label>
                                                ))}
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                                <button
                                                    type="button"
                                                    className={stylesp.loginButton}
                                                    style={{ borderRadius: "0px 0px 10px 10px" }}
                                                    onClick={() => setAttributesOpen(false)}
                                                >
                                                    Done
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {displayAttributes.map((name, index) => (
                                    <div key={`${name}-${index}`} className={styles.dropdownresult}>
                                        {name} <div onClick={() => toggleDisplayAttribute(name)}><Closecircle /></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </>
    );
};

export default EditLevelForm;
